<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.chapterCode ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="章节名" prop="chapterName">
          <el-input v-model="dataForm.chapterName" placeholder="章节名"></el-input>
      </el-form-item>
          <el-form-item label="是否收费" prop="type">
            <el-radio-group v-model="dataForm.type">
              <el-radio :label="0">免费</el-radio>
              <el-radio :label="1">收费</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="章节内容" prop="chapterContent">
          <div style="border: 1px solid #ccc;">
            <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"
            />
            <Editor
                style="height: 200px; overflow-y: hidden;"
                v-model="dataForm.chapterContent"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
            />
        </div>
      </el-form-item>
          <el-form-item label="小说ID" prop="novelCode">
          <el-input v-model="dataForm.novelCode" :disabled="true" placeholder="小说ID"></el-input>
      </el-form-item>
      <el-form-item label="小说下标" prop="sortNum">
          <el-input v-model="dataForm.sortNum"  placeholder="从1开始"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="close()">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<script>
import debounce from 'lodash/debounce'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
  components: { Editor, Toolbar },
  data () {
    return {
      visible: false,
      editor: null,
      html: '<p>hello</p>',
      toolbarConfig: { },
      editorConfig: { placeholder: '请输入内容...' },
      mode: 'default', // or 'simple'
      dataForm: {
        chapterCode: '',
        chapterName: '',
        sortNum:'',
        chapterContent: '',
        text: '',
        novelCode: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        chapterName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        chapterContent: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        novelCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.dataForm.novelCode = localStorage.getItem("novelCode")
        if (this.dataForm.chapterCode) {
          this.getInfo()
        }
      })
    },
    onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/novelinfo/novelinfo/${this.dataForm.chapterCode}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    close(){
      this.dataForm = {}
      this.visible = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.chapterContent = encodeURIComponent(this.dataForm.chapterContent )
        this.$http[!this.dataForm.chapterCode ? 'post' : 'put']('/novelinfo/novelinfo/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
}
}
</script>
